import theme from "styled-theming";

export default {
  action: theme("mode", {
    light: "#123440",
    dark: "#123440",
  }),
} as const;
